import { defineMessage } from 'react-intl';

export const onlineMeetingCommonI18n = {
  google_meet: defineMessage({
    id: 'common:online-meeting.google-meet',
    defaultMessage: 'Google Meet'
  }),
  microsoft_teams: defineMessage({
    id: 'common:online-meeting.microsoft-teams',
    defaultMessage: 'Microsoft Teams'
  }),
  other: defineMessage({
    id: 'common:online-meeting.other',
    defaultMessage: 'third-party video conferencing platform'
  }),
  zoom: defineMessage({
    id: 'common:online-meeting.zoom',
    defaultMessage: 'Zoom'
  })
};
